import React, { useEffect, useState } from 'react';
import { COLUMNS } from './allVoucherColumn';
import AllVoucherPaginated from './AllVoucherPaginated';
import { ValidatorForm } from 'react-form-validator-core';
import { connect } from 'react-redux';
import {
	voucherTemplateDetail,
	clearVoucherTemplate,
} from '../../../actions/voucher';
import { getDate, getDisplayDate, selectValueGetter } from '../../../utils/helper';
import {
	RedeemVoucher,
	getVoucherTemplateStatusByCode,
	getVouchersWallet,
	transactionRegistration,
	getVoucherTemplateByMerchantCode,
} from '../../../services/services';
import swal from 'sweetalert';
import { decrypt } from '../../../utils/encodingdecoding';
import { Link } from 'react-router-dom';
import Header from '../../layout/Header';
import SelectValidator from '../../partial/SelectValidator';

const AllVouchers = ({
	voucherTemplateDetail,
	VoucherTemplate,
	clearVoucherTemplate,
}) => {
	const [loader, setLoader] = useState(false);
	const [response, setResponse] = useState();
	const [remarks, setRemarks] = useState('');
	const [valueselect, setValueSelect] = useState('all');
	const [option] = useState([
		{ label: 'All Vouchers', value: 'all' },
		{ label: 'Active Vouchers', value: 'Active' },
		{ label: 'Expired Vouchers', value: 'InActive' },
		{ label: 'Redeemed Vouchers', value: 'Redeemed' },
	]);

	const [filterOption, setFilterOption] = useState('all');
	const [data, setData] = useState([]);
	const [templateOptions, setTemplateOptions] = useState([]);
	const [selectedTemplate, setSelectedTemplate] = useState('all');

	const unPeople = (e) => {
		setValueSelect(e.value);
		setFilterOption(e.value);
	};

	const fetch = async () => {
		setLoader(true);

		const id = decrypt(localStorage.getItem('merchantcode'));
		const token = JSON.parse(localStorage.getItem('token_gen'));

		clearVoucherTemplate();

		try {
			const [voucherRes, templateRes, merchantTemplateRes] = await Promise.all([
				getVouchersWallet(token.access_token, id),
				voucherTemplateDetail(token.access_token),
				getVoucherTemplateByMerchantCode(token.access_token),
			]);

			setResponse(voucherRes.data);

			const templateDropdown = merchantTemplateRes?.data?.map((item) => ({
				label: item.name,
				value: item.code,
			}));

			setTemplateOptions([
				{ label: 'All Templates', value: 'all' },
				...templateDropdown,
			]);
		} catch (error) {
			console.error(error);
		} finally {
			setLoader(false);
		}
	};

	useEffect(() => {
		fetch();
	}, []);
	const onSubmit = () => { };

	const handleVoucher = async (value) => {
		setLoader(true);
		const token = JSON.parse(localStorage.getItem('token_gen'));
		const body = {
			customercode: value?.customerCode,
		};
		let voucherStatusResponse = await getVoucherTemplateStatusByCode(
			token?.access_token,
			body,
		);
		setLoader(false);
	};

	const handleRedeemtion = async (value) => {
		const id = localStorage.getItem('Id');
		setLoader(true);
		let tempToken = JSON.parse(localStorage.getItem('token_gen'));
		tempToken = tempToken?.access_token;
		let currentDate = new Date();
		let formattedDate = getDate(currentDate, 'YYYY/MM/DD');
		let body = {};
		body.customer = {
			customercode: value?.customercode,
		};
		body.redeemDetail = {
			walletType: 'voucher',
			voucherCode: value?.voucherCode,
			transactionType: 'redeem',
			transactionDate: formattedDate,
			VoucherTemplateCode: value?.voucherTemplateCode,
			remarks,
		};
		var temp = {
			customer: {
				customercode: value.customercode,
			},
			transactionDetail: {
				vouchertemplatecode: value?.voucherTemplateCode,
				value: value?.earnedValue,
			},
			schemacode: 'TSC000049',
		};
		await RedeemVoucher(tempToken, body).then((res) => {
			if (res.status === 400) {
				setLoader(false);
				swal({
					position: 'center',
					icon: 'error',
					title: res.message,
					showConfirmButton: false,
					timer: 5000,
				});
			} else {
				handleVoucher(value)
					.then((resp) => {
						setLoader(false);
						swal({
							position: 'center',
							icon: 'success',
							title: 'Voucher Redeemed Successfully',
							showConfirmButton: false,
							timer: 5000,
						});
						value?.voucherType.toLowerCase() == 'discount' &&
							transactionRegistration(
								tempToken,
								JSON.stringify(temp),
							);
					})
					.catch(() => {
						setLoader(false);
					});
				// CustomerWallets(tempToken, { "customercode": value.customercode }).then((res) => {
				//     console.log(res.data)

				// })
			}
		});
		const merchantcode = decrypt(localStorage.getItem('merchantcode'));
		const res = await getVouchersWallet(tempToken, merchantcode, selectedTemplate);
		setResponse(res.data);
		setLoader(false);
	};

	useEffect(() => {
		if (response && VoucherTemplate?.dataList) {
			const temp = response.map((voucher) => {
				const matchedVoucher = VoucherTemplate.dataList.find(
					(item) => item.code === voucher.voucherTemplateCode
				);
				return {
					...voucher,
					voucherName: matchedVoucher ? matchedVoucher.name : 'N/A',
					customerCode:

						<Link
							to={`/customer-view/${voucher?.customercode}`}
							state={{
								customerCode: voucher?.customercode,
							}}
						>
							{`${voucher?.customercode}`}
						</Link>,
					vouchercode: voucher.voucherCode,
					expiredate: getDisplayDate(voucher.expiryDate),
					value: voucher.earnedValue,
					action: (
						<button
							style={{ textTransform: 'capitalize' }}
							className={
								voucher.voucherUsed
									? 'badge bg-warning'
									: 'badge bg-success'
							}
							onClick={() => {
								handleRedeemtion(voucher);
							}}
							disabled={voucher?.voucherUsed}
						>
							{voucher?.voucherUsed ? 'redeemed' : 'redeem'}
						</button>
					),
				};
			});

			const currentDate = new Date();
			const filteredData = temp?.filter((val) => {
				let statusMatch = true;

				if (filterOption === 'Redeemed') {
					statusMatch = val.voucherUsed === true;
				} else if (filterOption === 'InActive') {
					statusMatch = new Date(val.expiryDate) < currentDate;
				} else if (filterOption === 'Active') {
					statusMatch = val.voucherUsed === false;
				}

				return statusMatch;
			});

			setData(filteredData.reverse());
		}
	}, [filterOption, response, VoucherTemplate]);

	const downloadCSV = () => {
		if (!data || data.length === 0) {
			swal({
				icon: 'warning',
				title: 'No data to download',
			});
			return;
		}

		const headers = [
			'Voucher Name',
			'Voucher Code',
			'Customer Code',
			'Value',
			'Expiry Date',
			'Status',
		];
		const rows = data.map((item) => [
			item.voucherName,
			item.vouchercode,
			item.customercode,
			item.value,
			item.expiredate,
			item.voucherUsed ? 'Redeemed' : 'Active',
		]);

		const csvContent =
			[headers, ...rows]
				.map((row) => row.map((val) => `"${val}"`).join(','))
				.join('\n');

		const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
		const url = URL.createObjectURL(blob);

		const link = document.createElement('a');
		link.href = url;
		link.setAttribute('download', 'voucher_list.csv');
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	const handleTemplateChange = async (e) => {
		const value = e.value;
		setSelectedTemplate(value);

		const token = JSON.parse(localStorage.getItem('token_gen'));
		const merchantcode = decrypt(localStorage.getItem('merchantcode'));

		setLoader(true);

		try {
			let res;
			const body = {}
			if (value === 'all') {
				res = await getVouchersWallet(token.access_token, merchantcode)
			} else {
				res = await getVouchersWallet(token.access_token, merchantcode, value)
			}
			if (res.message === "Success") {
				setResponse(res.data);
			} else {
				setResponse([]);
			}
		} catch (error) {
			console.error(error);
		} finally {
			setLoader(false);
		}
	};

	return (
		<>
			<Header name={'Vouchers'} />
			{loader && (
				<div className='mainPreloaderMain'>
					<div className='mainPreloader'>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>
			)}
			<div className='dashboard__content'>
				<div className='container-fluid'>
					<div className='dashboard__transactionsCard'>
						<div className='dashboard__header'>
							<div className='dashboard__left'>
								<h4 id='transction_list'>All Vouchers List</h4>
							</div>
							<div className="dashboard__right">
								<button onClick={downloadCSV} className="btn btn-default">
									<i
										class="fa-solid fa-download"
										style={{ marginRight: "10px" }}
									></i>
									Download Voucher
								</button>
							</div>
						</div>
						<div className="dashboard__body">
							<div
								className="dashboard__heading"
								style={{ justifyContent: 'end', marginBottom: '0' }}
							>
								<div className="dashboard__headingRight">

									<ValidatorForm onSubmit={onSubmit}>

										<div className="d-flex align-items-center gap-2">
											<div style={{ minWidth: '180px' }}>
												<SelectValidator
													placeholder="Template"
													name="template"
													value={selectValueGetter(templateOptions, selectedTemplate)}
													options={templateOptions}
													onChange={handleTemplateChange}
												/>
											</div>
											<div style={{ minWidth: '200px' }}>
												<SelectValidator
													placeholder="Status"
													name="status"
													value={selectValueGetter(option, valueselect)}
													options={option}
													onChange={unPeople}
												/>
											</div>
										</div>

									</ValidatorForm>
								</div>
							</div>

							<AllVoucherPaginated
								data={data}
								columns={COLUMNS}
								loader={loader}
								setLoader={setLoader}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state) => ({
	VoucherTemplate: state.VoucherTemplate,
});
const mapDispatchToProps = {
	voucherTemplateDetail,
	clearVoucherTemplate,
};

export default connect(mapStateToProps, mapDispatchToProps)(AllVouchers);
